import { Component, HostBinding, Input } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-ghost-button',
  templateUrl: './ghost-button.component.html',
})
export class GhostButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-ghost-button') hostBaseClass = true;
  @Input() inverted = false;
}
